export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";